// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandLinks_root__wPafH","item":"BrandLinks_item__WgQl1"};